import { EventEmitter } from 'events';
import * as Inovx from '@shared';
import EntitlementConstants from '../constants/EntitlementConstants';

var CommonMessages = Inovx.Shared.Common.CommonMessages;

declare var InovxLoader: any;

var ENTITLEMENT_CHANGE_EVENT = 'Entitlement.change';
var _securityGroups: ISecurityGroup[] = [],
    _settings: IEntitlementSettings = { IsExternalAuthentication: false },
    _externalGroups: IExternalGroup[] = [],
    _securityGroup: ISecurityGroup | any = getBlankSecurityGroup(false),

    _applicationPermissions: IApplicationPermission[] = [],
    _securityGroupDetail: ISecurityGroupDetail = getBlankSecurityGroupDetail(_applicationPermissions),

    _user: IUser = getBlankUser(),

    _beginAdd = false,
    _beginEdit = false,
    _modalVisible = false,
    _hasChanges = false,
    _validation: IValidationStoreObject = {};

function loadEntitlementData(data: ISecurityGroup[]) {
    fixSecurityGroupData(data);
    _securityGroups = data;
}

function loadEntitlementSettingsData(data: IEntitlementSettings) {
    _settings = data;
}

function loadExternalGroups(data: IExternalGroup[]) {
    _externalGroups = data;
}

function _updateSecurityGroup(comp: string, key: string, value: any) {
    switch (comp) {
        case EntitlementConstants.ENTITLEMENT_ADD_FORM:
            _updateChanges(key, value);
            _hasChanges = true;
            break;
    }
}

function _updateChanges(name: string, value: string) {
    switch (name) {
        case "IsLinkedGroup":
            _securityGroup[name] = value;
            if (_securityGroup.IsLinkedGroup == true) {
                if (_securityGroupDetail.LinkedExternalGroups.length == 0) {
                    _validation[EntitlementConstants.ENTITLEMENT_ADD_FORM][name].invalidValueMessage = InovxLoader.t("common:form.externalGroupEmpty");
                    _validation[EntitlementConstants.ENTITLEMENT_ADD_FORM][name].invalidValue = true;
                }
                else {
                    _setValidValidation(EntitlementConstants.ENTITLEMENT_ADD_FORM, name);
                }
            }
            else {
                _setValidValidation(EntitlementConstants.ENTITLEMENT_ADD_FORM, name);
            }
            break;
        case "Name":
            _securityGroup[name] = value;
            if (value) {

                var dupName = false;
                for (var i = 0; i < _securityGroups.length; i++) {
                    if (_securityGroup.Name.toUpperCase() === _securityGroups[i].Name.toUpperCase()
                        && _securityGroup.ID.toUpperCase() !== _securityGroups[i].ID.toUpperCase()) {
                        dupName = true;
                        break;
                    }
                }

                if (dupName) {
                    _validation[EntitlementConstants.ENTITLEMENT_ADD_FORM][name].invalidValue = true;
                    _validation[EntitlementConstants.ENTITLEMENT_ADD_FORM][name].invalidValueMessage = InovxLoader.t("Entitlement:message.invalidSecurityGroupName");
                } else {
                    _setValidValidation(EntitlementConstants.ENTITLEMENT_ADD_FORM, name);
                }
            } else {
                _validation[EntitlementConstants.ENTITLEMENT_ADD_FORM][name].invalidValue = true;
                _validation[EntitlementConstants.ENTITLEMENT_ADD_FORM][name].invalidValueMessage = CommonMessages.Validation.Required;
            }
            break;
        default:
            if (name != 'ID' && name != 'VersionToken') {
                _securityGroup[name] = value;
            }
            _setValidValidation(EntitlementConstants.ENTITLEMENT_ADD_FORM, name);
            break;
    }
}

function updatePermissions(uid: string, value: any) {
    var applicationPermissions = _securityGroupDetail.ApplicationPermissions;
    for (var index in applicationPermissions) {
        var applicationPermission = applicationPermissions[index];
        for (var subIndex in applicationPermission.Permissions) {
            var permission = applicationPermission.Permissions[subIndex];
            if (permission.ID == uid) {
                permission.Assigned = value;
                _hasChanges = true;
                break;
            }
        }
    }
}

function addUsers(users: IUser[]) {
    for (var indx in users) {
        var exists = false;
        for (var grpIndx in _securityGroupDetail.GroupUsers) {
            if (users[indx].UserID === _securityGroupDetail.GroupUsers[grpIndx].UserID) {
                exists = true;
                break;
            }
        }
        if (!exists) {
            _securityGroupDetail.GroupUsers.push(users[indx]);
        }
    }
    _hasChanges = true;
}

function deleteUser(user: IUser) {
    for (var index in _securityGroupDetail.GroupUsers) {
        if (_securityGroupDetail.GroupUsers[index].UserName == user.UserName) {
            _securityGroupDetail.GroupUsers.splice(index as any, 1);
            _hasChanges = true;
            break;
        }
    };
}

function addExternalGroup(externalGroup: IExternalGroup) {

    var exists = false;
    for (var grpIndx in _securityGroupDetail.LinkedExternalGroups) {
        if (externalGroup.ID === _securityGroupDetail.LinkedExternalGroups[grpIndx].ID) {
            exists = true;
            break;
        }
    }
    if (!exists) {
        _securityGroupDetail.LinkedExternalGroups.push(externalGroup);
        _hasChanges = true;
    }
}

function deleteExternalGroup(externalGroup: IExternalGroup) {
    for (var index in _securityGroupDetail.LinkedExternalGroups) {
        if (_securityGroupDetail.LinkedExternalGroups[index].ID == externalGroup.ID) {
            _securityGroupDetail.LinkedExternalGroups.splice(index as any, 1);
            _hasChanges = true;
            break;
        }
    };
}

function setAddingEntitlement(applicationPermissions: IApplicationPermission[], isLinkedGroup: boolean) {
    _beginAdd = _modalVisible = true;
    _beginEdit = false;
    _securityGroup = getBlankSecurityGroup(isLinkedGroup);
    _securityGroupDetail = getBlankSecurityGroupDetail(applicationPermissions);
    _user = getBlankUser();
    _hasChanges = false;
    _initalizeValidation(EntitlementConstants.ENTITLEMENT_ADD_FORM);
}

function setEditingEntitlement(securityGroup: ISecurityGroup, securityGroupDetail: ISecurityGroupDetail) {
    _modalVisible = _beginEdit = true;
    _beginAdd = false;
    _securityGroup = { ...securityGroup };
    _securityGroupDetail = { ...securityGroupDetail };
    _user = getBlankUser();
    _hasChanges = false;
    _initalizeValidation(EntitlementConstants.ENTITLEMENT_ADD_FORM);
}

function _initalizeValidation(comp: string) {
    switch (comp) {
        case EntitlementConstants.ENTITLEMENT_ADD_FORM:

            var valiObj: { [name: string]: IValidationObject } = _validation[EntitlementConstants.ENTITLEMENT_ADD_FORM] = {};

            for (var k in _securityGroup) {
                _setValidValidation(EntitlementConstants.ENTITLEMENT_ADD_FORM, k);
            }

            break;
    }
}

function _setValidValidation(comp: string, name: string) {
    if (_validation[comp][name]) {
        _validation[comp][name].invalidInput = false;
        _validation[comp][name].invalidValue = false;
    } else {
        _validation[comp][name] = _getNewValidationObject();
    }
}

function _getNewValidationObject() {
    return {
        invalidInput: false,
        invalidValue: false
    } as IValidationObject;
}

function _validate(comp: string) {
    switch (comp) {
        case EntitlementConstants.ENTITLEMENT_ADD_FORM:
            return _validateObject(comp, _securityGroup);
    }

    return false;
}

function _ensureValidObject(comp: string, obj: any) {
    for (var k in obj) {
        switch (comp) {
            case EntitlementConstants.ENTITLEMENT_ADD_FORM:
                var objType = typeof (obj[k]);
                if (objType !== 'function') {
                    if (obj[k] === null || objType !== 'object') {
                        _updateChanges(k, obj[k]);
                    } else if (obj.constructor !== Array) {
                        _ensureValidObject(comp, obj[k]);
                    }
                }
        }
    }
}

function _validateObject(comp: string, obj: any) {
    _ensureValidObject(comp, obj);

    for (var k in _validation[EntitlementConstants.ENTITLEMENT_ADD_FORM]) {
        if (_validation[EntitlementConstants.ENTITLEMENT_ADD_FORM][k].invalidValue) {
            return false;
        }
    }

    return true;
}

function finishedEditing() {
    _modalVisible = false;
    _hasChanges = false;
}

function getBlankSecurityGroup(isLinkedGroup: boolean): ISecurityGroup {
    return {
        ID: '',
        VersionToken: '',
        Name: '',
        Description: '',
        Type:'V-Plant',
        IsSystemDefault: false,
        IsLinkedGroup: isLinkedGroup
    };
}

function getBlankSecurityGroupDetail(applicationPermissions: IApplicationPermission[]): ISecurityGroupDetail {
    return {
        ApplicationPermissions: applicationPermissions,
        GroupUsers: [],
        LinkedExternalGroups: []
    };
}

function getBlankApplicationPermission(): IApplicationPermission {
    return {
        ApplicationDisplayName: null,
        Permissions: []
    };
}

function getBlankUser(): IUser {
    return {
        UserID: null,
        UserName: null,
        UserVersionToken: null,
        FirstName: null,
        LastName: null,
        Enabled: null,
    };
}

function fixSecurityGroupData(data: ISecurityGroup[]) {
    if (data) {
        data.forEach((group) => {
            if (group.IsLinkedGroup) {
                group.Type = InovxLoader.t('Entitlement:grid.linked');
            }
            else {
                group.Type = "V-Plant";
            }
        });
    }
}

var EntitlementStore = Object.assign({}, EventEmitter.prototype, {
    getExternalGroups: function () {
        return _externalGroups;
    },
    getAll: function () {
        return _securityGroups;
    },
    getSettings: function () {
        return _settings;
    },
    getSecurityGroup: function () {
        return _securityGroup;
    },
    getSecurityGroupDetail: function () {
        return _securityGroupDetail;
    },
    getUser: function () {
        return _user;
    },
    getIsAdding: function () {
        return _beginAdd;
    },
    getIsEditing: function () {
        return _beginEdit;
    },
    getHasChanges: function () {
        return _hasChanges;
    },
    getModalVisible: function () {
        return _modalVisible;
    },
    isLinkedGroup: function () {
        return _securityGroup.IsLinkedGroup;
    },
    getValidation(key: string) {
        return _validation[key];
    },
    getIsValidObject(key: string) {
        return _validate(key);
    },
    getIsValidEditObject() {
        return !(_securityGroup.IsSystemDefault && _securityGroup.Name === 'System Administrator' && _securityGroupDetail.GroupUsers.length == 0);
    },
    emitChange: function () {
        this.emit(ENTITLEMENT_CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(ENTITLEMENT_CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback:any) {
        this.removeListener(ENTITLEMENT_CHANGE_EVENT, callback);
    }
});

Inovx.Shared.Flux.AppDispatcher.register(function (payload:any) {
    switch (payload.actionType) {
        case EntitlementConstants.ENTITLEMENT_BEGIN_ADD:
            setAddingEntitlement(payload.applicationPermissions, payload.isLinkedGroup);
            break;
        case EntitlementConstants.ENTITLEMENT_BEGIN_EDIT:
            setEditingEntitlement(payload.securityGroup, payload.securityGroupDetail);
            break;

        case EntitlementConstants.ENTITLEMENT_FINISH_EDIT:
            finishedEditing();
            break;

        case EntitlementConstants.ENTITLEMENT_RECIEVE_DATA:
            loadEntitlementData(payload.data);
            break;

        case EntitlementConstants.ENTITLEMENT_RECIEVE_SETTINGS_DATA:
            loadEntitlementSettingsData(payload.data);
            break;

        case EntitlementConstants.ENTITLEMENT_UPDATE_SECURITY_GROUP:
            _updateSecurityGroup(payload.component, payload.key, payload.value);
            break;

        case EntitlementConstants.ENTITLEMENT_UPDATE_PERMISSIONS:
            updatePermissions(payload.uid, payload.value);
            break;

        case EntitlementConstants.ENTITLEMENT_ADD_USER:
            addUsers(payload.users);
            break;

        case EntitlementConstants.ENTITLEMENT_DELETE_USER:
            deleteUser(payload.user);
            break;

        case EntitlementConstants.ENTITLEMENT_ADD_EXTERNAL_GROUP:
            addExternalGroup(payload.externalGroup);
            break;

        case EntitlementConstants.ENTITLEMENT_DELETE_EXTERNAL_GROUP:
            deleteExternalGroup(payload.externalGroup);
            break;

        case EntitlementConstants.ENTITLEMENT_FORM_INVALID_SAVE:
            break;
        case EntitlementConstants.ENTITLEMENT_RECEIVE_SEARCH_HINT:
            loadExternalGroups(payload.data);
            payload.callback();
            return true;

        default: return true;
    }

    EntitlementStore.emitChange();

    return true;
});

export default EntitlementStore;
